import {KeyModifiers} from 'common/util/keyboard';

export enum Direction {
  Right = `right`,
  Left = `left`,
  Top = `top`,
  Bottom = `bottom`,
}

export interface ExtraPanelAction {
  icon: string;
  value: string;
  label: string;
}

export interface PanelAttrs {
  'disable-collapsing'?: boolean;
  loading?: boolean;
  'min-adjacent-size'?: number;
  'max-size'?: number;
  'max-auto-size'?: number;
  'min-size'?: number;
  'default-size'?: number;
  'storage-key'?: string;
  'show-collapse-button'?: boolean;
  'extra-actions'?: ExtraPanelAction[];
  'panel-name'?: string;
  'resize-direction'?: Direction;
  'default-ratio'?: number;
  'collapse-key'?: string;
  'collapse-key-modifier'?: KeyModifiers;
  'show-resizing-layout'?: boolean;
  'fixed-size'?: boolean;
}

export interface PanelState {
  canExpand: boolean;
  hasResized: boolean;
  isCollapsed: boolean;
  isResizing: boolean;
  size: number;
  currentRatio?: number;
  containerWidth: number;
  containerHeight: number;
  snapResetState?: boolean;
}

export type PersistedPanelState = Pick<PanelState, 'isCollapsed' | 'size' | 'currentRatio'>;

export interface PanelJsxProps {
  attrs?: PanelAttrs;
  on?: {
    panelResize?: (ev: CustomEvent<{size: number}>) => void;
  };
  props?: {
    containerEl?: HTMLElement;
  };
}
